import * as Msdyn365 from '@msdyn365-commerce/core';

export const replaceAccountToken = (
    text: Msdyn365.RichText | undefined,
    token: string,
    accountNumber?: string
): Msdyn365.RichText | undefined => {
    if (!text || !token) {
        return text;
    }

    if (!text.includes(token)) {
        return text;
    }
    const replacement = accountNumber ? encodeURIComponent(accountNumber) : 'null';

    let updatedText: Msdyn365.RichText = text;

    updatedText = updatedText.replace(token, replacement);

    // Keep replacing any additional occurrences
    while (updatedText.includes(token)) {
        updatedText = updatedText.replace(token, replacement);
    }

    return updatedText;
};
